import axiosInstance from '@/api/axiosInstance';

export const getMySales = async (params = {}) => {
  const response = await axiosInstance.get('/users/me/sales', { params });
  return response.data;
};

export const submitSaleShipment = async (saleId, data) => {
  const response = await axiosInstance.post(`/users/me/sales/${saleId}/shipment`, data);
  return response.data;
};

export const getSaleShipmentPreparation = async (saleId) => {
  const response = await axiosInstance.get(`/users/me/sales/${saleId}/shipment/preparation`);
  return response.data;
};

export const getSaleDetails = async (saleId) => {
  const response = await axiosInstance.get(`/users/me/sales/${saleId}`);
  return response.data;
};